module.exports = __webpack_public_path__ + "static/img/gonganbeian.d0289dc0.png";